exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-21b9bc4e] .dataTable input,[data-v-21b9bc4e] .dataTable label{font-size:14px!important}", ""]);

// exports
